export enum AccountType {
  Business = 'Business',
  Partner = 'Partner'
}